//测试地址
const title_dev = '智慧运营管理平台'         //登录页及浏览器名称
const favicon_dev = 'favicon.ico'                //浏览器图标
const monitortitle_dev = '医维保可视化平台'       //大屏名称
const mainlogo_dev = 'mainlogo.png'             //登录页图标
const logo_dev = 'logo.png'                     //菜单栏大图标
const minlogo_dev = 'logo.min.png'              //菜单栏小图标
const logo_dev_school = 'logos.png'                     //菜单栏大图标
const minlogo_dev_school = 'logo.mins.png'              //菜单栏小图标
const host_dev = 'http://sddyyy.hi-eweibao.com'  //域名
const img_dev = 'http://localhost'
// 线上地址
const title_online = '智慧运营管理平台'
const favicon_online = 'favicon.ico'
const monitortitle_online = '医维保可视化平台'
const mainlogo_online = 'mainlogo.png'
const logo_online = 'logo.png'
const minlogo_online = 'logo.min.png'
const logo_online_school = 'logos.png'                     //菜单栏大图标
const minlogo_online_school = 'logo.mins.png'              //菜单栏小图标
const host_online = 'https://hdsaas.hi-eweibao.com'
const img_online = 'https://ufsaas.hi-eweibao.com'
// 线上地址2
// const title_online2 = '上海市静安区中心医院信息科服务管理平台'
// const favicon_online2 = 'favicon2.ico'
// const monitortitle_online2 = '上海市静安区中心医院信息科服务可视化平台'
// const logo_online2 = 'logo2.png'
// const minlogo_online2 = 'logo.min2.png'
// const host_online2 = 'https://jingzhongxin.huakangmed.com'
// const img_online2 = 'https://jingzhongxin.huakangmed.com'
// 线上地址
const title_online3 = '智慧运营管理平台'
const favicon_online3 = 'favicon.ico'
const monitortitle_online3 = '医维保可视化平台'
const mainlogo_online3 = 'mainlogo.png'
const logo_online3 = 'logo.png'
const minlogo_online3 = 'logo.min.png'
const host_online3 = 'https://sphouduan.hi-eweibao.com'
const img_online3 = 'https://shopuf.hi-eweibao.com'

// 线上地址4
const title_online4 = '医印通集成自助打印项目'
const favicon_online4 = 'favicon.ico'
const monitortitle_online4 = '医印通集成自助打印项目可视化平台'
const mainlogo_online4 = 'mainlogo.png'
const logo_online4 = 'logo.png'
const minlogo_online4 = 'logo.min.png'
const host_online4 = 'https://yyt.huakangmed.com/'
const img_online4 = 'https://yyt.huakangmed.com/'

// 线上地址5
const title_online5 = '智慧运营管理平台'
const favicon_online5 = 'favicon.ico'
const monitortitle_online5 = '医维保可视化平台'
const mainlogo_online5 = 'mainlogo.png'
const logo_online5 = 'logo.png'
const minlogo_online5 = 'logo.min.png'
const host_online5 = 'https://tshouduan.hi-eweibao.com'
const img_online5 = 'https://tsuf.hi-eweibao.com'

// 线上地址6
const title_online6 = '金山区亭林医院信息科服务管理平台'
const favicon_online6 = 'favicon.ico'
const monitortitle_online6 = '金山区亭林医院信息科服务可视化平台'
const mainlogo_online6 = 'mainlogo.png'
const logo_online6 = 'logo.png'
const minlogo_online6 = 'logo.min.png'
const host_online6 = 'https://tlyy.huakangmed.com'
const img_online6 = 'https://tlyy.huakangmed.com'

// 线上地址7
const title_online7 = '浙江医院全场景服务平台'
const favicon_online7 = 'favicon.ico'
const monitortitle_online7 = '浙江医院全场景服务可视化平台'
const mainlogo_online7 = 'mainlogo.png'
const logo_online7 = 'logo.png'
const minlogo_online7 = 'logo.min.png'
const host_online7 = 'https://zjyy.huakangmed.com'
const img_online7 = 'https://zjyy.huakangmed.com'

const env = process.env
let NODE_ENV = env.NODE_ENV
let ENV_TYPE = env.ENV_TYPE
let logo = ''
let mainlogo = ""
let logoSchool = ''
let title = ''
let minlogo = ''
let minlogoSchool = ''
let monitortitle = ''
let favicon = ''
let apihost = ''
let imghost = ''
let publicPath = '/'

// 开发编译模式
if (NODE_ENV === 'production') {
  if (ENV_TYPE == 'online') {
    // online生产地址
    title = title_online
    mainlogo = mainlogo_online
    logo = logo_online
    minlogo = minlogo_online
    logoSchool = logo_online_school
    minlogoSchool = minlogo_online_school
    monitortitle = monitortitle_online
    favicon = favicon_online
    apihost = host_online
    imghost = img_online
    publicPath = ''
  }
  // if (ENV_TYPE == 'online2') {
  //   // online2生产地址
  //   title = title_online2
  //   logo = logo_online2
  //   minlogo = minlogo_online2
  //   monitortitle= monitortitle_online2
  //   favicon = favicon_online2
  //   apihost = host_online2
  //   imghost = img_online2
  //   publicPath = '/work/'
  // }
  if (ENV_TYPE == 'online3') {
    // online3生产地址
    title = title_online3
    mainlogo = mainlogo_online
    logo = logo_online
    minlogo = minlogo_online
    monitortitle = monitortitle_online3
    favicon = favicon_online3
    apihost = host_online3
    imghost = img_online3
    publicPath = '/'
  }
  if (ENV_TYPE == 'online4') {
    // online4生产地址
    title = title_online4
    mainlogo = mainlogo_online
    logo = logo_online
    minlogo = minlogo_online
    monitortitle = monitortitle_online4
    favicon = favicon_online4
    apihost = host_online4
    imghost = img_online4
    publicPath = '/'
  }
  if (ENV_TYPE == 'online5') {
    // online5生产地址
    title = title_online5
    logo = logo_online
    minlogo = minlogo_online
    monitortitle = monitortitle_online5
    favicon = favicon_online5
    apihost = host_online5
    imghost = img_online5
    mainlogo = mainlogo_online5
    publicPath = '/'
  }
  if (ENV_TYPE == 'online6') {
    // online5生产地址
    title = title_online6
    logo = logo_online
    minlogo = minlogo_online
    monitortitle = monitortitle_online6
    favicon = favicon_online6
    apihost = host_online6
    imghost = img_online6
    mainlogo = mainlogo_online
    publicPath = '/'
  }
  if (ENV_TYPE == 'online7') {
    // online5生产地址
    title = title_online7
    logo = logo_online
    minlogo = minlogo_online
    monitortitle = monitortitle_online7
    favicon = favicon_online7
    apihost = host_online7
    imghost = img_online7
    mainlogo = mainlogo_online
    publicPath = '/'
  }
  if (ENV_TYPE == 'dev') {
    // dev生产地址
    title = title_dev
    mainlogo = mainlogo_dev
    logo = logo_dev
    minlogo = minlogo_dev
    logoSchool = logo_dev_school
    minlogoSchool = minlogo_dev_school
    monitortitle = monitortitle_dev
    favicon = favicon_dev
    apihost = host_dev
    imghost = img_dev
    publicPath = '/'
  }
} else {
  // dev开发地址
  title = title_dev
  mainlogo = mainlogo_dev
  logo = logo_dev
  minlogo = minlogo_dev
  logoSchool = logo_dev_school
  minlogoSchool = minlogo_dev_school
  monitortitle = monitortitle_dev
  favicon = favicon_dev
  apihost = host_dev
  imghost = img_dev
  publicPath = '/'
}

module.exports = {
  env: NODE_ENV,
  env_type: ENV_TYPE,
  title: title,
  mainlogo: mainlogo,
  logo: logo,
  minlogo: minlogo,
  logoSchool: logoSchool,
  minlogoSchool: minlogoSchool,
  monitortitle: monitortitle,
  favicon: favicon,
  API_HOST: apihost,
  IMAGE_HOST: imghost,
  publicPath: publicPath,
}
